import { GetContrastColorBW, stringToHexColor } from "@opendash/core";
import { Tag } from "antd";
import { observer } from "mobx-react-lite";
import React from "react";
import { useMetaTranslate } from "../hooks/useMetaTranslate";

type Props = {
  metaField: string;
};

export const SourceMetaTag = observer((props: Props) => {
  const mt = useMetaTranslate();

  return (
    <Tag
      color={stringToHexColor(props.metaField)}
      style={{
        color: GetContrastColorBW(stringToHexColor(props.metaField)),
      }}
    >
      {mt(props.metaField)}
    </Tag>
  );
});
